import * as Yup from "yup";

/**
 * Everything needed to fulfil an order without an account.
 * Name and email are the only hard requirements — email because it is where
 * the confirmation and the private tracking link are sent, and losing it means
 * losing access to the order.
 */
export const checkoutSchema = Yup.object({
  customer_name: Yup.string().trim().min(2, "Please enter your full name").required("Required"),
  customer_email: Yup.string().trim().email("Enter a valid email").required("Required"),
  customer_phone: Yup.string().trim().max(40, "Too long"),
  customer_country: Yup.string().trim().max(60, "Too long"),
  address_line1: Yup.string().trim().max(120, "Too long"),
  address_line2: Yup.string().trim().max(120, "Too long"),
  city: Yup.string().trim().max(80, "Too long"),
  state: Yup.string().trim().max(80, "Too long"),
  postal_code: Yup.string().trim().max(20, "Too long"),
  notes: Yup.string().trim().max(2000, "Too long"),
});

export const checkoutInitialValues = {
  customer_name: "",
  customer_email: "",
  customer_phone: "",
  customer_country: "",
  address_line1: "",
  address_line2: "",
  city: "",
  state: "",
  postal_code: "",
  notes: "",
};
